// Platform-admin badge helpers. Maps the admin-console-specific status strings
// (dashboard monitor health, comped flag) onto the shared Badge StatusKey palette so
// the console reuses the same learnable pill colors as the tenant app.
import type { StatusKey } from '../../theme';
import type { HealthStatusEnum } from '@beam/api-types';

type BadgeSpec = { key: StatusKey; label: string };

/** Dashboard monitor health → badge. ok=green, warn=amber, critical=red, unknown=neutral. */
export function monitorBadge(status: HealthStatusEnum): BadgeSpec {
  switch (status) {
    case 'ok':
      return { key: 'paid', label: 'OK' };
    case 'warn':
      return { key: 'inProgress', label: 'Warn' };
    case 'critical':
      return { key: 'overdue', label: 'Critical' };
    default:
      return { key: 'draft', label: 'Unknown' };
  }
}
